import styled from 'styled-components';

export const SearchFieldWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
`;
export const ResultWrapper = styled('div')`
  cursor: pointer;
`;
